import { curry } from 'lib/util'
import { updateAll } from 'app/_shared/events/notification/alert'

/**
 * Sets all notifications as read
 *
 * NOTE: Does not, unlike {@link update}, toggle the `read` state of the notifications. So there
 * is no 'set all as unread' functionality.
 *
 * @param {Function} callback                 callback to execute
 * @param {Gaia.AppModule.Spec} module        module composition
 * @param {Gaia.Component.Spec} component     action component
 * @param {Gaia.AppModule.EventHandler} event triggered event
 * @returns {Promise<void>}
 * @private
 */
const _updateAll = async (callback, module, component, event) => {
  await updateAll(module, component, null, callback, event)
}

export default curry(_updateAll)
